import BoardRoleBadgeView from "./BoardRoleBadgeView";

import { UserKanbanBoardRole } from "@/generated/graphql";

/**
 * Props for BoardRoleBadge container component
 */
interface BoardRoleBadgeProps {
  role: UserKanbanBoardRole;
}

/**
 * Container component for board role badge
 * Displays user's permission level on the kanban board
 * @param root0 - Component props
 * @param root0.role - User's role on the board (VIEWER, EDITOR, or OWNER)
 */
const BoardRoleBadge = ({ role }: BoardRoleBadgeProps) => (
  <BoardRoleBadgeView role={role} />
);

export default BoardRoleBadge;
